const apiUrl = process.env.REACT_APP_API_URL;

export const PostJutgePracticaIdDocument = async (idPrac: string, document: any) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${idPrac}/document`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(document)
        });
        return await response.json();
    } catch (error) {
        console.log('Error:', error);
    }
};
